module.exports = __webpack_public_path__ + "assets/img/baa1-cv.svg";